import React from 'react'

const tiles = [
  {
    icon: 'fa-solid fa-microchip',
    title: 'PLC Programming',
    description:
      'Custom PLC programming and commissioning for Siemens, Allen-Bradley, and Mitsubishi platforms to automate your manufacturing processes.',
  },
  {
    icon: 'fa-solid fa-display',
    title: 'SCADA & HMI Systems',
    description:
      'Real-time monitoring and control through SCADA and HMI integration, giving operators full visibility of the production floor.',
  },
  {
    icon: 'fa-solid fa-gears',
    title: 'Control System Integration',
    description:
      'End-to-end integration of sensors, variable frequency drives, servo systems, and controllers into a unified automation solution.',
  },
  {
    icon: 'fa-solid fa-bolt',
    title: 'Electrical Panel Design',
    description:
      'Design, engineering, and fabrication of industrial control panels built to IEC and IS standards for safe and reliable operation.',
  },
  {
    icon: 'fa-solid fa-industry',
    title: 'Plant Electrical Support',
    description:
      'On-site electrical installation, maintenance, and fault-finding services to keep your production running without interruption.',
  },
  {
    icon: 'fa-solid fa-chart-line',
    title: 'Energy Optimisation',
    description:
      'Power quality analysis and energy audit solutions that identify inefficiencies and reduce electricity costs across your plant.',
  },
]

export const ServiceTiles = () => {
  return (
    <section className="services-section">
      <div className="services-wrapper">
        <h2 className="services-heading">Our Services</h2>
        <p className="services-subheading">
          Delivering PLC automation and electrical engineering expertise to the
          manufacturing industry
        </p>
        <div className="tiles-grid">
          {tiles.map((tile, index) => (
            <div className="tile-card" key={index}>
              <div className="tile-icon-wrapper">
                <i className={tile.icon}></i>
              </div>
              <h3 className="tile-title">{tile.title}</h3>
              <p className="tile-description">{tile.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
